import type { ReactNode } from "react";
import { jitUserProvisioningEnabled } from "../../../../shared/jitProvisioning";
import type { SsoConfig } from "./constants";
import { OidcFields } from "./OidcFields";
import { SamlFields } from "./SamlFields";
import { SyncModeFields } from "./SyncModeFields";

export function SsoProviderFormFields({
  config,
  onConfigChange,
  existing,
  scimTokenSection,
}: {
  config: SsoConfig;
  onConfigChange: (updater: (prev: SsoConfig) => SsoConfig) => void;
  existing?: boolean;
  scimTokenSection?: ReactNode;
}) {
  const jitSection = (
    <SyncModeFields
      state={{ syncMode: config.syncMode }}
      onChange={(next) =>
        onConfigChange((f) => ({ ...f, syncMode: next.syncMode }))
      }
      scimTokenSection={scimTokenSection}
    />
  );

  // In SCIM mode the IdP owns profile data through the SCIM endpoints, so the
  // SAML attribute mapping is only collected when JIT provisions users.
  const mappingRelevant = jitUserProvisioningEnabled({
    syncMode: config.syncMode,
  });

  const props = { config, onConfigChange, existing, jitSection };
  return config.protocol === "oidc" ? (
    <OidcFields {...props} />
  ) : (
    <SamlFields {...props} mappingRelevant={mappingRelevant} />
  );
}
